/**
 * Provides an `onRequest` interceptor for `useFetch` / `$fetch` that aborts the
 * request before it is sent when the user has no valid access token (e.g. after logout).
 * Spread the returned object into the fetch options: `...useAbortIfNotAuthenticated()`
 *
 * NOTE: Cannot be used inside `useUserStore` itself (circular dependency).
 * The user store keeps a local equivalent instead.
 */
export function useAbortIfNotAuthenticated() {
  const userStore = useUserStore()
  return {
    onRequest({ options }: { options: { signal?: AbortSignal } }) {
      if (!userStore.accessToken) options.signal = AbortSignal.abort()
    },
  }
}
